import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { getDocumentsApi, postDocumentsApi, putDocumentsApi, deleteDocumentsApi, getSecureAccountsApi, putAccountsApi, deleteAccountsApi, postSecureAccountsApi } from "@Shared/utils/ajax";
import { cloneDeep, map } from "lodash";
import Vue from "vue";
export const getDocuments = (applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}`;
  return getDocumentsApi({
    client: clientUsername
  }, endpoint);
};
export const getDocumentClassifications = (applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}`;
  return getDocumentsApi({
    client: clientUsername
  }, endpoint);
};
export const getDocumentRequestList = async (queryDrafts = false) => {
  const {
    documentRequestLists
  } = await getDocumentsApi({}, `/request-list?draft=${queryDrafts}`);
  return documentRequestLists;
};
export const updateRequestDetails = (applicationId, clientUsername, requestId, details) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${requestId}`;
  return putDocumentsApi(details, endpoint);
};
export const downloadDocument = (documentId, fileName, applicationId, clientUsername, download = true) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApi({
    fileName,
    client: clientUsername,
    applicationId: applicationId,
    download
  }, endpoint);
};
export const downloadDocumentNoClient = (documentId, fileName) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApi({
    fileName
  }, endpoint);
};
export const downloadAllDocumentsAsPdf = async (applicationId, clientUsername, documentRequestsIds) => {
  const endpoint = `/application/${applicationId}/combined-pdf`;
  return getDocumentsApi({
    client: clientUsername,
    documentRequestsIds: btoa(_JSON$stringify({
      documentRequestsIds
    }))
  }, endpoint);
};
export const downloadAllDocumentsAsZip = async (applicationId, clientUsername, documentRequestsIds) => {
  const endpoint = `/application/${applicationId}/zip`;
  return getDocumentsApi({
    client: clientUsername,
    documentRequestsIds: btoa(_JSON$stringify({
      documentRequestsIds
    }))
  }, endpoint);
};
export const getSignedURL = (fileName, clientUsername, documentRequestId) => {
  const endpoint = "/signed-s3-url";
  const payload = {
    client: clientUsername,
    documentRequestId
  };
  return getDocumentsApi(_objectSpread(_objectSpread({}, payload), {}, {
    fileName
  }), endpoint);
};
export const createSignedUrls = (filesInfo, applicationId, clientUsername, documentRequestId) => {
  const endpoint = `/application/${applicationId}/signed-s3-url`;
  const payload = {
    clientUsername,
    documentRequestId
  };
  return postDocumentsApi(_objectSpread(_objectSpread({}, payload), {}, {
    filesInfo
  }), endpoint);
};
export const markUploadCompleted = async (clientUsername, applicationId, classificationType, documentDescription, documentS3Key, documentRequestId, encrypted = false) => {
  const {
    brokerageDetails
  } = Vue.auth.session.get();
  const brokerageId = brokerageDetails.tiedBrokerages[0].brokerageId;
  const endpoint = `/${documentS3Key}`;
  return postDocumentsApi({
    client: clientUsername,
    classificationType,
    applicationId: applicationId,
    brokerageId,
    documentOptions: {
      documentRequestId,
      documentDescription
    },
    encrypted
  }, endpoint);
};
export const createOrUpdateDocumentRequestList = async documentRequestList => {
  return postDocumentsApi(documentRequestList, "/request-list");
};
export const sendComment = async (documentId, comment) => {
  const endpoint = `/${documentId}/comment`;
  return postDocumentsApi({
    comment
  }, endpoint);
};
export const createDocumentClassification = async (applicationId, clientUsername, documentRequests) => {
  var _context;
  const formattedDocumentRequests = _mapInstanceProperty(_context = cloneDeep(documentRequests)).call(_context, documentRequest => {
    const sampleDocuments = map(documentRequest.sampleDocuments, documentId => ({
      documentId
    }));
    return _objectSpread(_objectSpread({}, documentRequest), {}, {
      sampleDocuments
    });
  });
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}`;
  return postDocumentsApi({
    documentRequests: formattedDocumentRequests
  }, endpoint);
};
export const updateDocumentStatus = async (applicationId, clientUsername, requestId, documentNumber, status) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${requestId}/document/${documentNumber}/${status}`;
  return postDocumentsApi({}, endpoint);
};
export const renameDocument = async (documentId, newName, clientUsername) => {
  const params = {};
  if (clientUsername) params.client = clientUsername;
  const endpoint = `/${documentId}?${$.param(params)}`;
  return putDocumentsApi({
    fileName: newName
  }, endpoint);
};
export const deleteDocument = async (clientUsername, applicationId, documentId, documentNumber, isSample = false, documentRequestId) => {
  const params = $.param(_objectSpread(_objectSpread({
    clientUsername,
    documentNumber
  }, isSample && {
    applicationId
  }), isSample && {
    documentRequestId
  }));
  const endpoint = `/${documentId}?${params}`;
  return deleteDocumentsApi(endpoint);
};
export const deleteDocumentRequest = async (applicationId, clientUsername, requestId) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${requestId}`;
  return deleteDocumentsApi(endpoint);
};
export const getEmailTemplates = (templateType = "document-request") => {
  const endpoint = "/email/template";
  return getSecureAccountsApi({
    templateType
  }, endpoint);
};
export const createEmailTemplate = templateInfo => {
  const endpoint = "/email/template";
  return postSecureAccountsApi(templateInfo, endpoint);
};
export const getEmailTemplate = templateId => {
  const endpoint = `/email/template/${templateId}`;
  return getSecureAccountsApi({}, endpoint);
};
export const updateEmailTemplate = (templateId, newTemplateInfo) => {
  const endpoint = `/email/template/${templateId}`;
  return putAccountsApi(_objectSpread({}, newTemplateInfo), endpoint);
};
export const deleteEmailTemplate = templateId => {
  const endpoint = `/email/template/${templateId}`;
  return deleteAccountsApi(endpoint);
};
export const resetGuestUpload = (applicationId, clientUsername, coApplicantId, requestId, sendNotification = true) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/reset-guest-upload`;
  return postDocumentsApi({
    sendNotification,
    coApplicantId,
    requestId
  }, endpoint);
};
export const updateDocumentRequestSort = async (name, documentRequests) => {
  const endpoint = `/request-list/${encodeURIComponent(name)}/order`;
  return putDocumentsApi({
    documentRequests: _mapInstanceProperty(documentRequests).call(documentRequests, docRequest => _objectSpread(_objectSpread({}, docRequest), {}, {
      documentRequestListId: docRequest.id
    }))
  }, endpoint);
};
export const updateDocumentRequestItem = async (documentRequestId, name, data) => {
  const endpoint = `/request-list/${encodeURIComponent(name)}/item/${documentRequestId}`;
  return putDocumentsApi(data, endpoint);
};
export const deleteDocumentRequestItem = async (documentRequestId, name) => {
  const endpoint = `/request-list/${encodeURIComponent(name)}/item/${documentRequestId}`;
  return deleteDocumentsApi(endpoint);
};
export const deleteDocumentRequestSample = async (documentRequestId, documentId) => {
  const endpoint = `/request-list/classification/${documentRequestId}/document/${documentId}`;
  return deleteDocumentsApi(endpoint);
};
export const markDocumentRequestUploadCompleted = async (documentRequestId, documentS3Key) => {
  const endpoint = `/request-list/classification/${documentRequestId}`;
  return postDocumentsApi({
    documentS3Key
  }, endpoint);
};
export const getDocumentTypes = async () => {
  const endpoint = `/customize/document-type`;
  return getSecureAccountsApi({}, endpoint);
};
export const updateDocumentType = async (documentTypeId, title, description) => {
  const endpoint = `/customize/document-type/${documentTypeId}`;
  return putAccountsApi({
    title,
    description
  }, endpoint);
};
export const deleteDocumentType = async documentTypeId => {
  const endpoint = `/customize/document-type/${documentTypeId}`;
  return deleteAccountsApi(endpoint);
};
export const createDocumentType = async title => {
  const endpoint = `/customize/document-type/`;
  return postSecureAccountsApi({
    title
  }, endpoint);
};
export const documentTypesOrder = async order => {
  const endpoint = `/customize/document-type/order`;
  return putAccountsApi({
    order
  }, endpoint);
};
export const documentRequestsOrder = async (order, applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/order`;
  return putDocumentsApi({
    order
  }, endpoint);
};
export const moveDocument = async (applicationId, clientUsername, documentRequestId, documentId, newRequestId) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${documentRequestId}/document/${documentId}/classification`;
  return postDocumentsApi({
    newRequestId
  }, endpoint);
};
export const createDocumentTag = async label => {
  const endpoint = "/document-label";
  return postSecureAccountsApi(label, endpoint);
};
export const addLabelToDocument = async (documentId, labelId) => {
  const endpoint = `/${documentId}/label`;
  return postDocumentsApi({
    labelId
  }, endpoint);
};
export const removeLabelToDocument = async (documentId, labelId) => {
  const endpoint = `/${documentId}/label/${labelId}`;
  return deleteDocumentsApi(endpoint);
};
export const editDocumentTag = async label => {
  const endpoint = `/document-label/${label.id}`;
  return putAccountsApi(label, endpoint);
};
export const deleteDocumentTag = async labelId => {
  const endpoint = `/document-label/${labelId}`;
  return deleteAccountsApi(endpoint);
};
export const getDocumentLabels = () => {
  const endpoint = "/document-label";
  return getSecureAccountsApi({
    shared: true
  }, endpoint);
};
export const markMessagesAsRead = async (applicationId, clientUsername, documentRequestId, documentId) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${documentRequestId}/document/${documentId}/read-comments`;
  return postDocumentsApi({}, endpoint);
};
export const sendDocumentsToLender = async (body, applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}/client/${clientUsername}/send-to-lender`;
  return putDocumentsApi(body, endpoint);
};
export const extractDocumentValues = (documentId, fileName, documentType, applicationId, client) => {
  const endpoint = `/${documentId}/extract`;
  return getDocumentsApi({
    fileName,
    client,
    applicationId,
    documentType
  }, endpoint);
};